import { useRef } from "react";

import { ButtonPrimitive } from "@/components/elements/Button";
import { Input } from "@/components/primitives/input";
import { MagnifyingGlassIcon, XMarkIcon } from "@heroicons/react/20/solid";

export function SearchFilter(props: {
  searchTerm: string;
  onChange: (term: string) => void;
}) {
  const inputRef = useRef<HTMLInputElement>(null);
  return (
    <div className="relative flex w-full max-w-sm items-center">
      <Input
        ref={inputRef}
        placeholder="Filter syncs..."
        value={props.searchTerm}
        onChange={(e) => props.onChange(e.target.value)}
        size="md"
        className="h-8 w-full pl-10 text-sm"
        autoFocus
      />
      <div className="absolute left-0 top-0 flex h-full items-center px-2">
        <MagnifyingGlassIcon className="h-5 w-5 text-gray-400 dark:text-gray-400" />
      </div>
      {props.searchTerm.trim().length > 0 && (
        <div className="absolute right-0 top-0 z-10 flex h-full items-center px-2">
          <ButtonPrimitive
            className="opacity-50 hover:opacity-100"
            onClick={() => {
              props.onChange("");
              inputRef.current?.focus();
            }}
          >
            <XMarkIcon className="h-5 w-5" />
          </ButtonPrimitive>
        </div>
      )}
    </div>
  );
}
